module.exports = __webpack_public_path__ + "static/media/08_1440.0a298d38.jpeg";